import { connect } from 'react-redux'
import { setMiniSideBarState, selectedMiniSideBarMenuState } from 'Modules/searchPage/actions'
import MiniSideMenu from './MiniSideMenu'


const mapStateToProps = (state) => ({
  showMiniSideBar: state.searchPage.showMiniSideBar,
  menuName: state.searchPage.menuName,
})
const actions = {
  setMiniSideBarState,
  selectedMiniSideBarMenuState,
}
export default connect(mapStateToProps, actions)(MiniSideMenu)
